"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDeviceModelByProductCode = void 0;
var _useGetDevicesByParams = require("./store/useGetDevicesByParams");
var _helpers = require("../helpers");
var _paulCorePackage = require("paul-core-package");
const useGetDeviceModelByProductCode = _ref => {
  let {
    thingPDIDDevice = null,
    requiredType = '',
    anywayShow = false // only with requiredType
  } = _ref;
  const {
    thingProductDisplayClassification
  } = (0, _useGetDevicesByParams.useGetDeviceByPdid)({
    thingPDIDDevice
  }) || {};
  const deviceClassification = _paulCorePackage.functions.getDisplayClassification(thingProductDisplayClassification);
  const sensorType = anywayShow && requiredType && !deviceClassification ? requiredType : deviceClassification;
  const {
    model,
    version
  } = (0, _helpers.getModelDataByVersion)(thingProductDisplayClassification || _paulCorePackage.constants.defaultProductDisplayClassification[sensorType]);
  return {
    model,
    version,
    type: sensorType
  };
};
exports.useGetDeviceModelByProductCode = useGetDeviceModelByProductCode;